import { Slot } from '@radix-ui/react-slot';
import React, { PropsWithChildren } from 'react';
import { Link as ReactRouterLink, LinkProps as ReactRouterLinkProps } from 'react-router';
import { BreadcrumbLink } from '../ui/breadcrumb';
import { cn } from '@/lib/utils';

type LinkProps = {
	asChild?: boolean;
} & PropsWithChildren &
	React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>;

export function Link(props: LinkProps) {
	const { asChild, className, ...rest } = props;

	const Comp = asChild ? Slot : 'a';

	return <Comp className={cn('hover:text-gray-400', className)} {...rest} />;
}

export function RouterLink(props: ReactRouterLinkProps) {
	return (
		<Link asChild>
			<ReactRouterLink {...props} />
		</Link>
	);
}

export function BreadcrumbRouterLink(props: ReactRouterLinkProps) {
	return (
		<BreadcrumbLink asChild>
			<RouterLink {...props} />
		</BreadcrumbLink>
	);
}
